import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const MenuItem = styled.span<Props>`
  color: ${(props) => (props.focused ? Colors['text'] : Colors['text'])};
  cursor: pointer;
  font-family: ${(props) => (props.focused ? Fonts['bold'] : Fonts['regular'])};
  font-size: ${32 * Screen.widthRatio}px;
  height: ${37 * Screen.widthRatio}px;
  opacity: ${(props) => (props.focused ? '1' : '0.8')};
  margin-bottom: ${32 * Screen.widthRatio}px;
  padding-left: ${75 * Screen.widthRatio}px;
  width: fit-content;
`;

export default withAnimation(MenuItem);
